import ProductItem from "@/features/annotation/ui/product-item";
import { Flex, Text, Box } from "@radix-ui/themes";
import { useGondolaChangeGroupsFilters } from "../hooks/useGondolaChangeGroupsFilters";
import { useAppSelector } from "@/app/appStore";
import { selectFilters } from "@/entities/gondola-change-groups/model/slice";

interface AnnotatedCartItemProps {
  name: string;
  imageUrl: string;
  barcode: string;
  skuId: string;
  uom: string | null;
  tp?: number | null;
  fp?: number | null;
  fn?: number | null;
}

export function AnnotatedCartItem({
  name,
  imageUrl,
  barcode,
  skuId,
  uom,
  tp = null,
  fp = null,
  fn = null,
}: AnnotatedCartItemProps) {
  const { setSelectedProduct, clearSelectedProduct } =
    useGondolaChangeGroupsFilters();
  const filters = useAppSelector(selectFilters);

  const isSelected = String(filters.selectedSkuBaseId) === String(skuId);

  const handleClick = () => {
    if (isSelected) {
      clearSelectedProduct();
    } else {
      setSelectedProduct(skuId);
    }
  };

  const metrics = [
    { label: "TP", value: tp },
    { label: "FP", value: fp },
    { label: "FN", value: fn },
  ];

  return (
    <Box
      className={`p-2 rounded border ${
        isSelected
          ? "bg-blue-100 border-blue-300"
          : "hover:bg-gray-50 border-transparent"
      }`}
      onClick={handleClick}
    >
      <Flex align="start" gap="4" justify="between">
        <ProductItem
          name={name}
          imageUrl={imageUrl}
          barcode={barcode}
          skuId={skuId}
          unitOfMeasurement={uom}
        />
        <Flex direction="row" gap="4">
          {metrics.map(({ label, value }) => (
            <Flex key={label} align="center" direction="column" gap="2">
              <Text size="2" weight="medium" color="gray">
                {label}
              </Text>
              <Text size="2" weight="medium" color="gray" highContrast>
                {value != null ? value : "-"}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Box>
  );
}
